export const actionTypes = {
  CONNECT_SOCKET: "CONNECT_SOCKET",
  DISCONNECT_SOCKET: "DISCONNECT_SOCKET",
  SEND_MESSAGE: "SEND_MESSAGE",
};
